export const AD_TRANSITION_SOURCE_COOKIE_TTL_MS = 30 * 1000;
